export default "__VITE_ASSET__0e2ffe6b__"